import { Typography, Box } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import { Check } from "@material-ui/icons";
export const EmployersOptions = ({ employerView, classes }) => {
    const requestDemoLink = "https://www.youscience.com/demo-request/";
    const contactSupportLink = "https://www.youscience.com/contact-us/";
    const checkListText = [
        "Connect with talent whose skills match your industry needs",
        "Expand your labor pool to address labor shortages",
        "Access a skilled talent pipeline for key roles",
        "Enhance recruiting strategies and build local partnerships",
        "Promote diversity and retain talent within your community",
        "Increase employee engagement through community involvement",
    ];

    const iconColor = {
        color: "rgb(47, 127, 51)",
    };

    if (employerView) {
        return (
            <>
                <div style={{ padding: "20px" }}>
                    <div>
                        <span className={`${classes.employerViewSideHeading}`}>
                            Get in front of your talent earlier
                        </span>
                        <div
                            className={`${classes.employerViewSideHeadingText} ${classes.empBaseText}`}
                        >
                            Create a <strong>free company profile</strong> on YouScience®
                            Employer Spotlight to
                            <strong> connect with talented, certified students</strong>. Your
                            profile allows potential candidates to{" "}
                            <strong>discover your company</strong> and explore career
                            opportunities earlier.
                        </div>
                    </div>
                    <div>
                        <span className={`${classes.employerViewSideHeading}`}>
                            Why join?
                        </span>
                        <div className={`${classes.employerViewSideHeadingText}`}>
                            {checkListText.map((item, idx) => (
                                <Typography
                                    key={'key-' + idx}
                                    className={`${classes.employerViewSideHeadingText}`}
                                >
                                    <div className={classes.checkIconWithText}>
                                        <Check style={iconColor} /> {item}
                                    </div>
                                </Typography>
                            ))}
                        </div>
                    </div>
                    <p
                        className={`${classes.employerViewSideHeadingText}`}
                        style={{ marginTop: "2em" }}
                    >
                        Additional features are available for premium profiles.{" "}
                        <Link
                            className={`${classes.link} ${classes.contactSupportLink}`}
                            target="_blank"
                            href={requestDemoLink}
                        >
                            Schedule a demo
                        </Link>
                        .
                    </p>
                    <p className={`${classes.employerViewSideHeadingText}`}>
                        If you have any trouble signing in please reach out to
                        <span className={`${classes.link} ${classes.contactSupportLink}`}>
                            &nbsp;employersales@youscience.com
                        </span>
                    </p>
                </div>
            </>
        );
    } else {
        return (
            <>
                <div style={{ padding: "16px" }}>
                    <div
                        style={{ textAlign: "center" }}
                        className={`${classes.helpTextDescriptionText}`}
                    >
                        <strong>Having trouble logging in?</strong>
                        Ask your teacher or counselor for guidance on which tool your school
                        uses. If that doesn’t work, please{" "}
                        <Link
                            className={`${classes.link} ${classes.contactSupportLink}`}
                            target="_blank"
                            href={contactSupportLink}
                        >
                            Contact support.
                        </Link>
                    </div>
                </div>
            </>
        );
    }
};
